
import { Component } from '@angular/core';
import { ModalConfirmationDeleteAccountComponent } from "../modal-confirmation-delete-account/modal-confirmation-delete-account.component";
import { ModalConfirmationDeleteAccountService } from '../modal-confirmation-delete-account/service/modal-confirmation-delete-account.service';

@Component({
  selector: 'perfil-user-components-delet-account',
  imports: [ModalConfirmationDeleteAccountComponent],
  templateUrl: './delet-account.component.html',
  styleUrl: './delet-account.component.css'
})
export class DeletAccountComponent {

  constructor(
    private modalConfirmationDeleteAccountService: ModalConfirmationDeleteAccountService
  ) { }

  confirmation(): void {
    // Abrir el modal de confirmación
    this.modalConfirmationDeleteAccountService.openModal();
  }

}
